import { render } from "./breadcrumb.html?vue&type=template&id=8166e6aa&scoped=true&external"
import script from "./breadcrumb.ts?vue&type=script&lang=js&external"
export * from "./breadcrumb.ts?vue&type=script&lang=js&external"

import "./breadcrumb.scss?vue&type=style&index=0&id=8166e6aa&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8166e6aa"],['__file',"src/components/layout/breadcrumb/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8166e6aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8166e6aa', __exports__)) {
    api.reload('8166e6aa', __exports__)
  }
  
  module.hot.accept("./breadcrumb.html?vue&type=template&id=8166e6aa&scoped=true&external", () => {
    api.rerender('8166e6aa', render)
  })

}


export default __exports__